// -----------------------------upsell crousel on cart drawer-----------------------------
  function initUpsellCarousel() {
    const $carousel = $(".upsell-cart-slider");
    if ($carousel.length && !$carousel.hasClass("owl-loaded")) {
      $carousel.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        nav: true,
        navText: [
          '<span class="arrow-left">&#8592;</span>',
          '<span class="arrow-right">&#8594;</span>',
        ],
        dots: false,
        responsive: {
          0: { items: 1 },
          600: { items: 2 },
        },
      });
    }
  }

  // Observe changes in the cart drawer DOM
  const observer = new MutationObserver(() => {
    const carousel = document.querySelector(".upsell-cart-slider");
    if (carousel && !carousel.classList.contains("owl-loaded")) {
      initUpsellCarousel();
    }
  });

  // Start observing the cart drawer container
  document.addEventListener("DOMContentLoaded", () => {
    const drawer = document.querySelector("cart-drawer, .cart-drawer"); // Adjust selector if needed
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
    }

    // Also try on initial load in case drawer is pre-rendered
    initUpsellCarousel();
  });


// ---------------------------get-discount btn on cart drawer-----------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    if (e.target && e.target.classList.contains("apply-discount-btn")) {
      e.preventDefault();

      const discountBlock = e.target.closest(".discount-block");
      const message = discountBlock?.querySelector(".discount-message");

      if (message) {
        message.style.display = "block";
      }

      setTimeout(() => {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            window.location.href = `/checkout?discount=CheckOut10`;
          });
      }, 2000);
    }
  });
});


//---------------- Sparklayer Optimize -------------------
// const observer = new MutationObserver(() => {
//   document.querySelectorAll('.card-information.card-information-relative').forEach(parent => {
//     if (
//       parent.querySelector('.spark-product-card') &&
//       !parent.classList.contains('spark-checked')
//     ) {
//       const btn = parent.querySelector('.btn_card_buy_now');
//       if (btn) btn.style.display = 'none';
//       parent.classList.add('spark-checked');
//     }
//   });
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });
// if (!window.sparkObserverInitialized) {
//   window.sparkObserverInitialized = true;

//   console.log('🔥 SCRIPT LOADED');

//   function processSparkCards() {
//     document.querySelectorAll('.spark-product-card').forEach(function (sparkCard) {
//       var parent = sparkCard.closest('.card-information.card-information-relative');

//       if (!parent || parent.classList.contains('spark-checked')) return;

//       console.log('[Spark Debug] Found Spark card');

//       var btn = parent.querySelector('.btn_card_buy_now');
//       if (btn) {
//         btn.style.display = 'none';
//         console.log('[Spark Debug] Button hidden');
//       }

//       parent.classList.add('spark-checked');
//     });
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     console.log('🔥 DOM READY');

//     // initial run
//     processSparkCards();

//     var observer = new MutationObserver(function () {
//       console.log('[Spark Debug] Mutation detected');

//       processSparkCards();
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });

//     console.log('[Spark Debug] Observer started');
//   });
// }


const mediaSlider = document.querySelector('.media_slider');
const tabProductDesktop = document.querySelector('.tab_product_desktop');

if (mediaSlider.offsetHeight === 0) {
  tabProductDesktop.style.marginTop = '32px';
}

setTimeout(() => {
  const productGrid = document.querySelector('.product.grid');
  const mediaSlider = productGrid?.querySelector('.media_slider');

  if (
    productGrid &&
    mediaSlider &&
    mediaSlider.getBoundingClientRect().height === 0
  ) {
    productGrid.style.setProperty(
      'flex-direction',
      'column-reverse',
      'important'
    );
  }
}, 100);